var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-36 w-full h-full"},[_vm._v(" giftcard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }